import styled, { css } from 'styled-components';
import { GalleryZoomControlsContainer } from './gallery-image-slide-interactive.styled';
import { GallerySlide, GallerySlideAnimation } from './gallery-slide.styled';
import { GallerySlidersContainer } from './gallery-sliders.styled';
import { GalleryTitleContainer } from './gallery-title.styled';
/**
 * Gallery controller
 */
export const galleryInputControllerStyles = () => css `
	position: absolute;
	visibility: hidden;
	grid-row: 2;

	&:checked ~ ${GallerySlide} ${GallerySlideAnimation} {
		margin-left: 100%;
	}

	&:checked + ${GallerySlide} {
		display: block;

		${GallerySlideAnimation} {
			margin-left: 0;
		}
	}

	&:checked
		+ ${GallerySlide}
		+ ${GallerySlidersContainer}
		+ ${GalleryTitleContainer},
		&:checked
		+ ${GallerySlide}
		+ ${GalleryZoomControlsContainer}
		+ ${GallerySlidersContainer}
		+ ${GalleryTitleContainer} {
		display: block;
	}
`;
export const GalleryInputController = styled.input `
	${galleryInputControllerStyles}
`;
